import ImagePreview from './ImagePreview';

export default ImagePreview;
